// Route wrapper for the kiosk switch, so desktop can reach it from the menu.
//
// The setting itself is a dialog because it is three fields; on mobile it opens
// from a Me-tab tile, and on desktop a menu item needs a route to point at.
// Closing it returns where you came from rather than dumping you on Home.

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import KioskSetupDialog from '../../shared/KioskSetupDialog';

export default function KioskSetupScreen() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  return (
    <KioskSetupDialog
      open={open}
      onClose={(saved) => {
        setOpen(false);
        // Saving it on means this screen is now a panel, so go straight there —
        // otherwise the change is invisible until the next launch.
        navigate(saved ? '/wall' : -1);
      }}
    />
  );
}
